export default __webpack_public_path__ + "static/media/staking-hero-home.d6a5665d.svg";